"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceOrdersCustomerSearchQueryFE = exports.AllianceOrdersCustomerSearchQuery = exports.AllianceOrdersSearchQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const address_transport_1 = require("./address-transport");
exports.AllianceOrdersSearchQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    haulerID: typebox_1.Type.String(), // Comma-separated list of hauler IDs
    orderNumber: typebox_1.Type.Number(),
    status: typebox_1.Type.String(), // Comma-separated list of statuses
    allianceOrderID: typebox_1.Type.String(), // Comma-separated list of alliance order IDs
    closed: typebox_1.Type.Boolean(),
    allianceCustomerID: typebox_1.Type.String(), // Comma-separated list of alliance customer IDs
    requestedDeliveryDateBefore: typebox_1.Type.String(),
    requestedDeliveryDateAfter: typebox_1.Type.String(),
    expectedDeliveryDateBefore: typebox_1.Type.String(),
    expectedDeliveryDateAfter: typebox_1.Type.String(),
    requestedPickupDateBefore: typebox_1.Type.String(),
    requestedPickupDateAfter: typebox_1.Type.String(),
    expectedPickupDateBefore: typebox_1.Type.String(),
    expectedPickupDateAfter: typebox_1.Type.String(),
    material: typebox_1.Type.String(), // Comma-separated list of material names
    extendingRental: typebox_1.Type.Boolean(),
    needsAttention: typebox_1.Type.Boolean(),
    needsAttentionBilling: typebox_1.Type.Boolean(),
    recurringOnCall: typebox_1.Type.Boolean(),
    haulerConfirmedDelivery: typebox_1.Type.Boolean(),
    haulerConfirmedPickup: typebox_1.Type.Boolean(),
    ccRate: typebox_1.Type.Number(),
    priceType: typebox_1.Type.String(),
    serviceLocationCounty: typebox_1.Type.String(),
    serviceLocation: address_transport_1.AddressTransport,
    accountManagerID: typebox_1.Type.String(),
    createdBefore: typebox_1.Type.String(),
    createdAfter: typebox_1.Type.String(),
    updatedBefore: typebox_1.Type.String(),
    updatedAfter: typebox_1.Type.String(),
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortDescending: typebox_1.Type.Boolean(),
}));
exports.AllianceOrdersCustomerSearchQuery = typebox_1.Type.Partial(typebox_1.Type.Pick(exports.AllianceOrdersSearchQuery, [
    'orderNumber',
    'status',
    'closed',
    'expectedDeliveryDateBefore',
    'expectedDeliveryDateAfter',
    'expectedPickupDateBefore',
    'expectedPickupDateAfter',
    'serviceLocation',
    'material',
    'limit',
    'offset',
    'sortBy',
    'sortDescending',
]));
exports.AllianceOrdersCustomerSearchQueryFE = typebox_1.Type.Intersect([
    typebox_1.Type.Partial(typebox_1.Type.Pick(exports.AllianceOrdersSearchQuery, [
        'orderNumber',
        'closed',
        'expectedDeliveryDateBefore',
        'expectedDeliveryDateAfter',
        'expectedPickupDateBefore',
        'expectedPickupDateAfter',
        'serviceLocation',
        'material',
        'limit',
        'offset',
        'sortBy',
        'sortDescending',
    ])),
    typebox_1.Type.Partial(typebox_1.Type.Object({
        status: typebox_1.Type.Array(typebox_1.Type.String()),
    })),
]);
//# sourceMappingURL=alliance-order-search-query.js.map